// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import DCAssets from '../site-sections/DCAssets';

/**
 * Site → Assets. Reuses the existing digital-twin-backed asset explorer
 * (DCAssets reads :site_id from the route; hierarchy tree + real-time
 * telemetry via useDigitalTwin). Wrapped in the Carbon shell page; data wiring
 * is unchanged.
 */
export default function SiteAssets() {
  return (
    <div className="hs-page" style={{ maxWidth: 'none', height: '100%' }}>
      <DCAssets />
    </div>
  );
}
